import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Panel, Button } from "components/bootstrap";
import { PaginatedList } from "components/common";
import { ColumnTogglerProvider, ColumnToggler } from "security-app/components/common/ColumnToggler";
import {
  PaginationProvider,
  SelectedRowsProvider,
  ModalProvider,
  usePagination,
  useSetPagination
} from "common/contexts";
import AssetModals from "security-app/components/Assets/AssetModals";
import { AssetsTable, PriorityColumnInitializer } from "security-app/components/Assets/List";
import { useGetAssetsForEventPreview } from "security-app/hooks/useAssetsAPI";
const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
`;
const ToggleGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;
const AssetEventPreviewTable = ({ config = void 0, assetType, onAssetTypeChange }) => {
  const pagination = usePagination();
  const setPagination = useSetPagination();
  const {
    assets,
    loadingAssets,
    pagination: remotePagination
  } = useGetAssetsForEventPreview({
    page: pagination.page,
    perPage: pagination.perPage,
    orderBy: pagination.orderBy,
    direction: pagination.direction,
    config,
    assetType
  });
  const onPageChange = (newPage, newPerPage) => {
    setPagination({ ...pagination, page: newPage, perPage: newPerPage });
  };
  useEffect(() => {
    setPagination((prevPagination) => ({ ...prevPagination, page: 1 }));
  }, [assetType, setPagination]);
  const showDetailsFor = useMemo(() => ({ machine: assetType === "machine", user: assetType === "user" }), [assetType]);
  return /* @__PURE__ */ React.createElement(ColumnTogglerProvider, { cacheId: `assetEventPreview-${assetType}` }, /* @__PURE__ */ React.createElement(PriorityColumnInitializer, null), /* @__PURE__ */ React.createElement(Controls, null, /* @__PURE__ */ React.createElement(ToggleGroup, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: assetType === "machine" ? "primary" : "default",
      bsSize: "small",
      onClick: () => onAssetTypeChange("machine")
    },
    "Machines"
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: assetType === "user" ? "primary" : "default",
      bsSize: "small",
      onClick: () => onAssetTypeChange("user")
    },
    "Users"
  )), /* @__PURE__ */ React.createElement(ColumnToggler, null)), /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      activePage: pagination.page,
      pageSize: pagination.perPage,
      onChange: onPageChange,
      totalItems: remotePagination.total,
      useQueryParameter: false,
      showPageSizeSelect: false
    },
    /* @__PURE__ */ React.createElement(
      AssetsTable,
      {
        assets: assets || [],
        showDetailsFor,
        loadingAssets,
        showSelection: false,
        showDeleteAction: false,
        showEditAction: false
      }
    )
  ));
};
const AssetEventPreview = ({ config }) => {
  const [assetType, setAssetType] = useState("machine");
  return /* @__PURE__ */ React.createElement(Panel, { header: /* @__PURE__ */ React.createElement("h3", null, "Asset Preview") }, /* @__PURE__ */ React.createElement("p", null, "Assets that would be targeted for risk threshold events by this event definition."), /* @__PURE__ */ React.createElement(PaginationProvider, { initPage: 1, initPerPage: 5, initOrderBy: "name", initDirection: "asc" }, /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(AssetEventPreviewTable, { config: config.config, assetType, onAssetTypeChange: setAssetType }), /* @__PURE__ */ React.createElement(AssetModals, null)))));
};
export default AssetEventPreview;
